import React from 'react';
import { motion } from 'framer-motion';
export function RealCost() {
  return <section className="py-12 px-4 bg-cream" data-id="element-378">
      <div className="max-w-4xl mx-auto" data-id="element-379">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-380">
          <p className="text-lg md:text-xl text-navy/80 leading-relaxed font-medium max-w-3xl mx-auto" data-id="element-381">
            El verdadero costo de cuidar rara vez aparece en una factura.
          </p>
          <p className="text-lg md:text-xl text-navy/80 leading-relaxed font-medium max-w-3xl mx-auto mt-2" data-id="element-382">
            Pero se paga todos los días.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative" data-id="element-383">
          <div className="absolute inset-0 bg-terracotta/10 transform rotate-1 rounded-2xl" data-id="element-384" />
          <img src="https://cdn.magicpatterns.com/uploads/bDER26DfAPhrUNy8hhLoPc/image.png" alt="El Costo Real del Cuidado — Lo que pierdes en el proceso y la factura emocional" className="relative rounded-2xl shadow-xl w-full" data-id="element-385" />
        </motion.div>

        <p className="text-center text-lg md:text-xl text-navy/70 italic font-medium mt-6" data-id="element-386">
          Este es uno de los ejercicios del libro para poner en palabras lo que
          muchos cuidadores viven en silencio.
        </p>
      </div>
    </section>;
}